
import PropTypes from 'prop-types';
import './cocAcceptanceDecisions.scss';
import cn from 'classnames';
import {enumTypes, getEnumValue} from '../../../../utils/enumHelper';
import Label from 'infrastructure/js/components/Label/label';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import useLabels from 'infrastructure/js/hooks/useLabels';

export default function CocAcceptanceDecisions ({ items = null, onFileClick = null, loading = false }) {

  const labels = useLabels('mat.forms.cocTestForm.sectionListItem.acceptanceDecisions.');

  const hasItems = !!items?.length;

  const rows = items?.map(item => {
    const isAccepted = (item.decisionStatus === getEnumValue(enumTypes.COC_ACCEPTANCE_CYCLE_STATUS)('ACCEPTED'));
    return (
      <div key={item.id} className='item'>
        <div className='item-request'>
          <div className='column column-1'>{item.requestTime}</div>
          <div className='column column-2'>
            <span className='pl pl-move-up-right'/>
            <span>{labels.get('request')}</span>
          </div>
          <div className='column column-3'>
            <Label text={item.requestComment}/>
          </div>
          <div className='column column-4'>{''}</div>
          <div className='column column-5'>
            <Label text={item.requesterName}/>
          </div>
        </div>

        {/*if there is a Decision item*/}
        { !!item.decisionTime &&
        <div className='item-decision'>
          <div className='column column-1'>{item.decisionTime}</div>
          <div className='column column-2'>
            <span className={cn('pl pl-move-down-left', {'accepted': isAccepted}, {'declined': !isAccepted})}/>
            <span>{labels.get('decision')}</span>
          </div>
          <div className='column column-3'>
            <Label text={item.decisionComment}/>
          </div>
          {item.decisionAttachment ?
            <div className='column column-4'
                 onClick={() => item.decisionAttachment && onFileClick?.(item.decisionAttachment)}>
              <span className='pl pl-file'/>
              <Label className='file-name' text={item.decisionAttachment?.originalFileName}/>
            </div> :
            <div className='column column-4'>{''}</div>
          }
          <div className='column column-5'>
            <Label className='column-5-row' text={item.reviewerName}/>
            {!!item.reviewerEmail && <Label className='column-5-row' text={item.reviewerEmail}/>}
          </div>
        </div>}
      </div>
    )
  }) ?? [];

  return (
    <div className={cn('coc-acceptance-decisions', {loading})}>
      {loading && <Overlay.Loading/>}

      {!loading && !hasItems && <span className='no-items'>{labels.get('noItems')}</span>}

      <div className={cn('items-reveal', {open: hasItems})}>
        <div className='items-list'>
          {rows}
        </div>
      </div>
    </div>
  )
}

CocAcceptanceDecisions.propTypes = {
  items: PropTypes.array,
  onFileClick: PropTypes.func,
  loading: PropTypes.bool,
};
